import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import PropTypes from "prop-types";
import { _ } from "../utils/i18n";
import "./lightbox-gallery-style.css";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 20px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const Thumbnail = styled.div`
  height: 300px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;
const StyledGatsbyImage = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 3rem 0;
`;

const LoadMoreButton = styled.button`
  background-color: var(--color-primary);
  color: var(--color-white);
  border: 1px solid var(--color-primary);
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  @media (hover: hover) {
    &:hover {
      background-color: transparent;
      color: var(--color-primary);
    }
  }
`;

const LightBoxGallery = ({ images, numberOfVisibleImages }) => {
  const [visibleImages, setVisibleImages] = useState(numberOfVisibleImages);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = images.map((image) => ({
    src: image.sourceUrl,
  }));

  const loadMoreImages = () => {
    setVisibleImages((prev) => prev + 6);
  };

  return (
    <>
      <Wrapper>
        {images.slice(0, visibleImages).map((image, index) => (
          <Thumbnail
            key={index}
            onClick={() => {
              setCurrentIndex(index);
              setIsOpen(true);
            }}
          >
            {image.gatsbyImageData ? (
              <StyledGatsbyImage
                image={image.gatsbyImageData}
                alt={`Image ${index + 1}`}
              />
            ) : (
              <img src={image.sourceUrl} alt={`Image ${index + 1}`} />
            )}
          </Thumbnail>
        ))}
      </Wrapper>

      {visibleImages < images.length && (
        <ButtonWrapper>
          <LoadMoreButton onClick={loadMoreImages}>
            {_("Vis flere")}
          </LoadMoreButton>
        </ButtonWrapper>
      )}

      {isOpen && (
        <Lightbox
          slides={slides}
          open={isOpen}
          close={() => setIsOpen(false)}
          index={currentIndex}
          onIndexChange={setCurrentIndex}
        />
      )}
    </>
  );
};

LightBoxGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      sourceUrl: PropTypes.string.isRequired,
      gatsbyImageData: PropTypes.object,
    })
  ).isRequired,
  numberOfVisibleImages: PropTypes.number,
};

export default LightBoxGallery;
